import { render } from "./InlineNotification.vue?vue&type=template&id=88675092"
import script from "./InlineNotification.vue?vue&type=script&lang=js"
export * from "./InlineNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__